import { createSelector } from 'reselect'
import { userEmailOption } from 'src/components/UserDropdown/UserDropdown'
import { RootState } from 'src/redux/createRootReducer'
import { RecentUsersFullPaginatedDataState } from 'src/redux/recentUsersFullPaginatedData.reducer'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectReceiptAttachmentsListModels } from 'src/redux/selectors/data/receiptAttachments.selectors'
import { selectUserListModelsFromState } from 'src/redux/selectors/data/users.selectors'
import { UsersFullPaginatedDataState } from 'src/redux/usersFullPaginatedData.reducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

const selectReceiptAttachmentIdsFromState = (state: RootState): string[] =>
  state.app.requestVirtualCard.receiptAttachmentIds

export const selectReceiptAttachmentModelsList = createSelector(
  [selectReceiptAttachmentIdsFromState, selectReceiptAttachmentsListModels],
  (ids, receiptAttachments) => ids.map((id) => receiptAttachments[id]),
)

export const selectUploadingAttachmentsFromState = (
  state: RootState,
): Record<string, string> =>
  state.app.requestVirtualCard.uploadingAttachmentThumbnails

export const selectPostingVirtualCardFromState = (state: RootState): boolean =>
  state.app.requestVirtualCard.postingVirtualCard

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.requestVirtualCard.topLevelError

export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.requestVirtualCard.errorDetailMap

export const selectUsersFullPaginatedData = (
  state: RootState,
): UsersFullPaginatedDataState =>
  state.app.requestVirtualCard.usersFullPaginatedData
const selectUniqueUserIds = createSelector(
  [selectUsersFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueUserEmailOptions = createSelector(
  [selectUniqueUserIds, selectUserListModelsFromState],
  (ids, users) => ids.map((id) => userEmailOption(users[id])),
)
export const selectFilteredUserEmailOptions = createSelector(
  [selectUniqueUserEmailOptions],
  (options) => options.filter(() => true),
)

export const selectRecentUsersFullPaginatedData = (
  state: RootState,
): RecentUsersFullPaginatedDataState =>
  state.app.requestVirtualCard.recentUsersFullPaginatedData

const selectUniqueRecentUserIds = createSelector(
  [selectRecentUsersFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueRecentUserEmailOptions = createSelector(
  [selectUniqueRecentUserIds, selectUserListModelsFromState],
  (ids, users) => ids.map((id) => userEmailOption(users[id])),
)

export const selectFilteredRecentUserEmailOptions = createSelector(
  [selectUniqueRecentUserEmailOptions, selectUserListModelFromState],
  (options, user) =>
    options
      .filter(
        (option) =>
          user?.organizationId === option.details?.user?.organizationId,
      )
      .slice(0, 5),
)
